// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_Xe","pageSubTitle":"e_Ye"};